// CholesterolRatioCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Rasio Kolesterol";
const DESCRIPTION =
  "Kalkulator kolesterol dan kesehatan jantung: analisis rasio kolesterol total, LDL, HDL, dan trigliserida untuk menilai risiko penyakit jantung! Masukkan hasil tes darah untuk mendapatkan laporan rinci dengan interpretasi medis tentang rasio ideal - alat penting untuk pemantauan kesehatan preventif.";
const KEYWORDS =
  "hitung rasio kolesterol, kolesterol, jantung, kesehatan jantung, kesehatan, rasio, kalkulator rasio kolesterol";
const OG_URL =
  "https://do-calculate.com/calculator/id/cholesterol-ratio-calculator/";
function CholesterolRatioCalculator() {
  const [hdl, setHdl] = useState(0);
  const [ldl, setLdl] = useState(0);
  const [tg, setTg] = useState(0);
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      const hdlValue = parseFloat(hdl);
      const ldlValue = parseFloat(ldl);
      const tgValue = parseFloat(tg);
      const totalCholesterol = hdlValue + ldlValue + 0.2 * tgValue;
      const cholesterolHdlRatio = totalCholesterol / hdlValue;
      const ldlHdlRatio = ldlValue / hdlValue;
      let ldlHdlCategory = "";
      if (ldlHdlRatio < 2) {
        ldlHdlCategory = "Ideal";
      } else if (ldlHdlRatio < 5) {
        ldlHdlCategory = "Baik";
      } else {
        ldlHdlCategory = "Sangat Tinggi";
      }
      const tgHdlRatio = tgValue / hdlValue;
      let tgHdlCategory = "";
      if (tgHdlRatio <= 0.87) {
        tgHdlCategory = "Ideal";
      } else if (tgHdlRatio <= 2.62) {
        tgHdlCategory = "Tinggi";
      } else {
        tgHdlCategory = "Sangat Tinggi";
      }
      setResult({
        totalCholesterol: totalCholesterol.toFixed(2),
        ldlHdlRatio: ldlHdlRatio.toFixed(2),
        ldlHdlCategory,
        tgHdlRatio: tgHdlRatio.toFixed(2),
        tgHdlCategory,
        cholesterolHdlRatio: cholesterolHdlRatio.toFixed(2),
      });
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>Kalkulator ini membantu Anda mengetahui rasio kolesterol dan kesehatan jantung.</p>
                <p>
                  Memahami tingkat kolesterol adalah langkah pertama menuju jantung yang sehat. Kalkulator ini memungkinkan Anda memahami arti hasil tes kolesterol Anda. Dengan memasukkan nilai Anda, Anda akan mendapatkan interpretasi sederhana dari kolesterol total, LDL, HDL, dan TG. Gunakan informasi ini untuk membuat keputusan berdasarkan informasi tentang kesehatan Anda.
                </p>
                <p>
                  Peduli dengan kesehatan jantung Anda! Kalkulator ini membantu Anda memperkirakan kesehatan jantung Anda dengan menghitung berbagai rasio kolesterol. Dengan memasukkan nilai kolesterol total, LDL (kolesterol jahat), HDL (kolesterol baik), dan TG (trigliserida), Anda akan mendapatkan gambaran tentang seberapa seimbang tingkat kolesterol Anda.
                </p>
                <p>
                  <b>
                    Penting: Harus ditekankan bahwa kalkulator ini hanyalah alat bantu, dan tidak boleh diandalkan sebagai diagnosis medis. Jika Anda memiliki kekhawatiran tentang kesehatan Anda, Anda harus berkonsultasi dengan dokter Anda.
                  </b>
                </p>
                <p>
                  Kalkulator dikembangkan berdasarkan{" "}
                  <a
                    href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2747394/"
                    rel="nofollow"
                  >
                    Perpustakaan Kedokteran Internasional
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="hdl">
                        HDL - Lipoprotein Kepadatan Tinggi (Kolesterol Baik)
                      </label>
                      <input
                        id="hdl"
                        type="number"
                        value={hdl}
                        onChange={(e) => setHdl(e.target.value)}
                        placeholder="Masukkan tingkat HDL"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="ldl">
                        LDL - Lipoprotein Kepadatan Rendah (Kolesterol Jahat)
                      </label>
                      <input
                        id="ldl"
                        type="number"
                        value={ldl}
                        onChange={(e) => setLdl(e.target.value)}
                        placeholder="Masukkan tingkat LDL"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="tg">
                        TG - Trigliserida
                      </label>
                      <input
                        id="tg"
                        type="number"
                        value={tg}
                        onChange={(e) => setTg(e.target.value)}
                        placeholder="Masukkan tingkat TG"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Error: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Hasil:</h4>
                      <p className="text-white">
                        Total Kolesterol: {result.totalCholesterol}
                      </p>
                      <p className="text-white">
                        Rasio Kolesterol / HDL: {result.cholesterolHdlRatio}
                      </p>
                      <p className="text-white">
                        Rasio LDL/HDL: {result.ldlHdlRatio} -{" "}
                        {result.ldlHdlCategory}
                      </p>
                      <p className="text-white">
                        Rasio TG/HDL: {result.tgHdlRatio} -{" "}
                        {result.tgHdlCategory}
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Detail Lebih Lanjut</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Rasio Kolesterol</h2>
                  </u>
                  <p>
                    Kolesterol adalah zat lemak yang diperlukan untuk berbagai fungsi tubuh. Namun, kelebihannya dapat menyebabkan masalah kesehatan.
                  </p>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Memahami Nilai</h2>
                  </u>
                  <p>
                    Nilai LDL yang rendah dan kadar HDL yang tinggi membantu mengurangi risiko penyakit jantung. Penting juga untuk memantau rasio TG/HDL karena ini adalah indikator kesehatan jantung.
                  </p>
                  <p>
                    <b>Rasio HDL (Kolesterol Baik):</b>
                  </p>
                  <ul>
                    <li>Untuk pria: di atas 40 mg/dL</li>
                    <li>Untuk wanita: di atas 50 mg/dL</li>
                  </ul>
                  <p>
                    <b>Rasio LDL (Kolesterol Jahat):</b>
                  </p>
                  <ul>
                    <li>Tingkat ideal: kurang dari 100 mg/dL</li>
                    <li>Tingkat tinggi: antara 130-159 mg/dL</li>
                    <li>Sangat tinggi: di atas 160 mg/dL</li>
                  </ul>
                  <p>
                    <b>Rasio TG (Trigliserida):</b>
                  </p>
                  <ul>
                    <li>Tingkat normal: kurang dari 150 mg/dL</li>
                    <li>Tingkat tinggi: antara 200-499 mg/dL</li>
                    <li>Sangat tinggi: di atas 500 mg/dL</li>
                  </ul>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Cara Meningkatkan Rasio Kolesterol
                    </h2>
                  </u>
                  <p>
                    Makan makanan kaya serat, berolahraga, dan menghindari lemak jenuh dapat membantu meningkatkan rasio kolesterol dalam tubuh Anda.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CholesterolRatioCalculator;